import { Link, useLocation } from 'react-router-dom';

import haggleLogo from '@/assets/haggle-logo.png';
import omnicergeLogo from '@/assets/omnicierge-logo.png';

type PropTypes = {
	href: string;
	width: number;
	height: number;
};
export default function Logo({ href, width, height }: PropTypes) {
	const location = useLocation();

	// Check if the current route is a consumer route
	const isConsumerRoute = location.pathname.includes('customer');
	const brandImage = isConsumerRoute ? haggleLogo : omnicergeLogo;
	const altText = isConsumerRoute ? 'Haggle Logo' : 'Omnicierge Logo';

	return (
		<Link to={href}>
			<img
				className={``}
				src={brandImage}
				width={width}
				height={height}
				alt={altText}
			/>
		</Link>
	);
}
